module.exports = __webpack_public_path__ + "static/media/sidebar2.60a14ca5.jpg";